var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6224 0.276045C1.25141 -0.0918556 0.64974 -0.0920384 0.278528 0.275637C-0.0926846 0.643312 -0.0928657 1.23961 0.278123 1.60752L3.69845 4.99937L0.278123 8.39122C-0.0928657 8.75912 -0.0926846 9.35542 0.278528 9.7231C0.64974 10.0908 1.25141 10.0906 1.6224 9.72269L5.04191 6.33165L8.3776 9.63956C8.74859 10.0075 9.35026 10.0076 9.72147 9.63997C10.0927 9.2723 10.0929 8.67599 9.72188 8.30809L6.38537 4.99937L9.72188 1.69064C10.0929 1.32274 10.0927 0.726437 9.72147 0.358762C9.35026 -0.00891314 8.74859 -0.00873002 8.3776 0.35917L5.04191 3.66709L1.6224 0.276045Z",
    fill: "#20242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.bbdd639ae63b90a4d5ff877d3d3c62a4.svg";
export { ForwardRef as ReactComponent };